import React from 'react';
import Card from 'styleguide/layout/Card';

export type Props = {
  active?: boolean;
  component: React.FC<any>;
  data: { [key: string]: any };
  disabled: boolean;
  showItemCard?: boolean;
  dataProps?: any;
  dataTestId?: string;
  dataTestIds?: { [key: string]: string };
};

const DataListItem: React.FC<Props> = ({
  active,
  component: Component,
  data,
  disabled = false,
  showItemCard,
  dataProps,
  dataTestId,
  dataTestIds,
}) => {
  if (showItemCard) {
    return (
      <Card disabled={disabled} active={active}>
        <Component
          data={data}
          dataProps={dataProps}
          dataTestId={dataTestId}
          dataTestIds={dataTestIds}
        />
      </Card>
    );
  } else {
    return (
      <Component
        data={data}
        disabled={disabled}
        active={active}
        dataProps={dataProps}
        dataTestId={dataTestId}
        dataTestIds={dataTestIds}
      />
    );
  }
};

export default React.memo(DataListItem);
